import { useState } from 'react';
import { useUIStore } from '../../../../store';
import { Order } from '../../../../interfaces/domain/menu';
import { CartItem } from '../../cards/CartItems';
import { TotalCart } from '../TotalCart';
import { FaAngleLeft } from 'react-icons/fa';

import styles from './Cart.module.scss';

interface OrdersCart {
  orders: Order[];
  total: number;
  visible: boolean; // ✅ controla visibilidad sin desmontar
}

export const Cart = ({ orders, total, visible }: OrdersCart) => {
  const setSection = useUIStore((s) => s.setSection);
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false); // reset para próxima apertura
      setSection("home");
    }, 300);
  };



  return (
    // ✅ CSS hidden cuando no es visible
    <div className={visible ? undefined : styles.cartHidden}>
      <div
        className={`${styles.overlay} ${isClosing ? styles.fadeOut : ''}`}
        onClick={handleClose}
      />
      <aside
        className={`${styles.container} ${isClosing ? styles.containerClosing : ''}`}
      >
        <button className={styles.closeButton} onClick={handleClose}>
          <FaAngleLeft size={36} />
        </button>

        <div className={styles.containerMyorder}>
          <h2 className={styles.title}>Mi Pedido</h2>

          <div className={styles.containerOrder}>
            {orders.map((order) => (
              <div key={order.cartItemId} className={styles.containerItem}>
                <CartItem order={order} />
              </div>
            ))}
          </div>

          <div className={styles.totalCartDesktop}>
            <TotalCart orders={orders} total={total} />
          </div>
        </div>
      </aside>
    </div>
  );
};
